import { module } from 'modujs';
import gsap, { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);

        this.$container = this.el;
        this.$image = this.$('image')[0];
    }

    init() {
        this.parallax = gsap.to(this.$image, {
            y: () => this.$image.offsetHeight - this.$container.offsetHeight,
            ease: "none",
            scrollTrigger: {
                trigger: this.$container,
                start: "top bottom",
                end: "bottom 70%",
                scrub: true,
                invalidateOnRefresh: true
            }
        })
    }

    destroy() {
    }
}